/**
 * Removes the placeholder content generated by the Angular CLI (as long as it
 * is wrapped by the "placeholder comments" generated by the CLI).
 * @param content HTML file content.
 * @returns HTML file without the placeholder content.
 */
export function removeHtmlAppComponentPlaceholder(content: string): string {
  const placeholderStart = `\
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->`;
  const placeholderEnd = `\
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content above * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * End of Placeholder * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->`;
  const startIdx = content.indexOf(placeholderStart);
  const endIdx = content.lastIndexOf(placeholderEnd);
  return startIdx !== -1 && endIdx !== -1
    ? content.slice(0, startIdx) + content.slice(endIdx + placeholderEnd.length)
    : content;
}

/**
 * Removes the `<router-outlet>` generated by the Angular CLI for the app
 * component (as long as it is in the expected position: at the end of the
 * file).
 * @param content HTML file content.
 * @returns HTML file content without the CLI generated router outlet.
 */
export function removeHtmlAppComponentRouterOutlet(content: string): string {
  const outletRegExp = /(^|\n)<router-outlet><\/router-outlet>\s*$/;
  return content.replace(outletRegExp, '');
}

/**
 * Removes the default CLI generated content in the HTML file of a module.
 * @param content HTML file content.
 * @param moduleName Name of the module.
 * @returns HTML file content without the CLI generated default content.
 */
export function removeHtmlModuleDefaultContent(
  content: string,
  moduleName: string
): string {
  const defaultContent = `<p>${moduleName} works!</p>`;
  return content.replace(defaultContent, '');
}

/**
 * Whether the provided HTML file is an unmodified version of the Angular CLI
 * generated app component (ignores added spaces and content modified within the
 * "template" comments).
 * @param content HTML file content.
 * @returns Whether the HTML file content is an unmodified version of the CLI
 * generated app component.
 */
export function isUnmodifiedHtmlAppComponent(content: string): boolean {
  return (
    removeHtmlAppComponentPlaceholder(
      removeHtmlAppComponentRouterOutlet(content)
    ).trim() === ''
  );
}

/**
 * Whether the provided HTML file is an unmodified version of the Angular CLI
 * generated module content (ignores added spaces).
 * @param content HTML file content.
 * @param moduleName Name of the module.
 * @returns Whether the HTML file content is an unmodified version of the CLI
 * generated module content.
 */
export function isUnmodifiedHtmlModuleComponent(
  content: string,
  moduleName: string
): boolean {
  return removeHtmlModuleDefaultContent(content, moduleName).trim() === '';
}
